import { graphql, useStaticQuery } from "gatsby"

import { DownloadModel } from "../model/downloadModel"

const useDownloads = () => {
  return useStaticQuery(graphql`
    query DownloadsQuery {
      allStrapiDownloads {
        edges {
          node {
            id
            related_products {
              id
            }
            description {
              key
            }
            strapiId
            markets {
              name {
                key
              }
              id
            }
            brands {
              name {
                key
              }
              id
            }
            availability_regions {
              name {
                key
              }
              id
            }
            product_groups {
              value {
                key
              }
              id
            }
            application {
              value {
                key
              }
              id
            }
            pdf_file {
              name {
                key
                value_en
              }
              id
              pdf_file_items {
                file {
                  url
                  localFile {
                    publicURL
                    extension
                    size
                    childScreenshot {
                      screenshotFile {
                        childImageSharp {
                          gatsbyImageData(width: 56, layout: CONSTRAINED)
                        }
                      }
                    }
                  }
                }
                language
              }
            }
            type
            group
          }
        }
      }
    }
  `)
    .allStrapiDownloads.edges.filter(
      ({ node }) =>
        node.pdf_file &&
        node.pdf_file.pdf_file_items &&
        node.pdf_file.pdf_file_items.length > 0,
    )
    .map(({ node }) => DownloadModel.fromStrapi(node))
}

export default useDownloads
